import React, { useState, useRef } from 'react';
import { connect } from 'react-redux';
import { Field } from 'react-final-form';
import InlineHelpText from '../../shared/InlineHelpText';
import { FormattedMessage } from 'react-intl';
import {
  // noStatusText,
  // notesText,
} from '../../shared/SharedInternationalizations';
import HelpIcon from '../../shared/HelpIcon';
import AccessControl from '../../../AccessControl';
import permissions from '../../../permissionsList';
import { Condition,ConditionMassnotificationSysParams } from '../../shared/Condition';








export function UnconnectedUserContactForm(props) {
  
  
  
  const { values, massNotificationAccess, } = props;


  const [showContactEmailHelpText, setShowContactEmailHelpText] = useState(
    false
  );
  const contactEmailHelpTextRef = useRef();
  function toggleContactEmailHelpText(value) {
    setShowContactEmailHelpText(value);
  }
  const contactEmailHelpText = (
    <FormattedMessage
      id="userContactForm.contactEmailHelpText"
      defaultMessage="This is the contact email address for this user. This email is the email address that the user would prefer to be contacted through and may be a personal email or other email. This may or may not be the same as an email address used for alerts."
      description="Help text."
    />
  );

  const [showContactPhoneHelpText, setShowContactPhoneHelpText] = useState(
    false
  );
  const contactPhoneHelpTextRef = useRef();
  function toggleContactPhoneHelpText(value) {
    setShowContactPhoneHelpText(value);
  }
  const contactPhoneHelpText = (
    <FormattedMessage
      id="userContactForm.contactPhoneHelpText"
      defaultMessage="This is the contact phone number for this user. This number is the number that the user would prefer to be contacted through and may be a personal number or other number. This may or may not be the same as a phone number used for alerts."
      description="Help text."
    />
  );

  





  const [
    showMakeEmailAlertDeviceHelpText,
    setShowMakeEmailAlertDeviceHelpText,
  ] = useState(false);
  const makeEmailAlertDeviceHelpTextRef = useRef();
  function toggleShowMakeEmailAlertDeviceHelpText(value) {
    setShowMakeEmailAlertDeviceHelpText(value);
  }
  const makeEmailAlertDeviceHelpText = (
    <FormattedMessage
      id="userContactForm.makeEmailAlertDeviceHelpText"
      defaultMessage="This will create an alert device using this email address and assign it to this user. The options for this device will be shown to you as you continue through the user creation process."
      description="Help text."
    />
  );
  const [
    showMakePhoneAlertDeviceHelpText,
    setShowMakePhoneAlertDeviceHelpText,
  ] = useState(false);
  const makePhoneAlertDeviceHelpTextRef = useRef();
  function toggleShowMakePhoneAlertDeviceHelpText(value) {
    setShowMakePhoneAlertDeviceHelpText(value);
  }
  const makePhoneAlertDeviceHelpText = (
    <FormattedMessage
      id="userContactForm.makePhoneAlertDeviceHelpText"
      defaultMessage="This will create an alert device using this phone number and assign it to this user. The options for this device will be shown to you as you continue through the user creation process"
      description="Help text."
    />
  );


  const [
    showMakeMassnotificationDeviceHelpText,
    setShowMakeMassnotificationDeviceHelpText,
  ] = useState(false);
  const makeMassnotificationDeviceHelpTextRef = useRef();
  function toggleShowMakeMassnotificationDeviceHelpText(value) {
    setShowMakeMassnotificationDeviceHelpText(value);
  }
  const makeMassnotificationDeviceHelpText = (
    <FormattedMessage
      id="userContactForm.makeMassnotificationHelpText"
      defaultMessage="This will create mass notification devices using multiple contacts to be assign to this user."
      description="Help text."
    />
  );


  

  return (
    <React.Fragment>
      <div className="content-display__container">
        <div className="content-display__column content-display__column--1-2">
          <div className="content-display__item-container">
            <div className="item-container__main-container">
              <label className="text-large text-light text-deep-blue">
                <FormattedMessage
                  id="userContactForm.contactEmailTitle"
                  defaultMessage="Email Address:"
                  description="The user's contact email address"
                />
              </label>
              <Field
                className="form-item__field"
                name="email"
                component="input"
                type="email"
                pattern="^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$"
                validate={(values) => {
                  const regex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
                  if (values) {
                    if (regex.test(values)) {
                      return undefined;
                    } else {
                      return 'Please use the following format: xxx@xx.xxx';
                    }
                  } else {
                    return undefined;
                  }
                }}>
                {({ input, meta }) => (
                  <React.Fragment>
                    <input
                      {...input}
                      type="email"
                      pattern="/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/"
                      className={
                        meta.error
                          ? 'form-item__field--noInvalid form-item__field--noInvalid--error'
                          : 'form-item__field--noInvalid'
                      }
                    />
                    {meta.error && (
                      <span className="form-item__field-message--required text-small">
                        {meta.error}
                      </span>
                    )}
                  </React.Fragment>
                )}
              </Field>
            </div>
            <div className="item-container__info-container">
              <HelpIcon
                onClick={() => contactEmailHelpTextRef.current.toggleHelpText()}
                toggled={showContactEmailHelpText}
                styles="margin-left-5"
              />
            </div>
          </div>
          <InlineHelpText
            ref={contactEmailHelpTextRef}
            toggleFunction={toggleContactEmailHelpText}
            message={contactEmailHelpText}
          />
        </div>
        <div className="content-display__column content-display__column--1-2">
          <Condition when="hasEmailDevice" is={false}>
            <AccessControl
              data-test="access-control"
              feature={permissions.static.devices.alert.addAlertDevice}>
              <div className="content-display__item-container">
                <div className="item-container__main-container">
                  <Field
                    className="visually-hidden"
                    name="makeEmailAlertDevice"
                    component="input"
                    type="checkbox"
                    id="makeEmailAlertDevice"
                    disabled={values.email === '' || values.email === undefined}
                  />
                  <label
                    htmlFor="makeEmailAlertDevice"
                    className={
                      values.email === '' || values.email === undefined
                        ? 'text-large text-dimmed text-light form-item__field-toggle'
                        : 'text-large text-light text-deep-blue form-item__field-toggle'
                    }>
                    <FormattedMessage
                      id="userContactForm.makeEmailAlertDeviceText"
                      defaultMessage="Create an alert device using this email address"
                      description="The user's title such as 'Mr', 'Ms','Dr', etc "
                    />
                  </label>
                </div>
                <div className="item-container__info-container">
                  <HelpIcon
                    onClick={() =>
                      makeEmailAlertDeviceHelpTextRef.current.toggleHelpText()
                    }
                    toggled={showMakeEmailAlertDeviceHelpText}
                    styles="margin-left-5"
                  />
                </div>
              </div>
            </AccessControl>
          </Condition>
          <InlineHelpText
            ref={makeEmailAlertDeviceHelpTextRef}
            toggleFunction={toggleShowMakeEmailAlertDeviceHelpText}
            message={makeEmailAlertDeviceHelpText}
          />
        </div>
        <div className="content-display__column content-display__column--1-2">
          <div className="content-display__item-container">
            <div className="item-container__main-container">
              <label className="text-large text-light text-deep-blue">
                <FormattedMessage
                  id="userContactForm.contactPhoneLabel"
                  defaultMessage="Primary Phone Number:"
                  description="The user's contact phone number"
                />
              </label>
              <Field
                className="form-item__field"
                name="phone"
                component="input"
                type="tel"
                pattern="[0-9:,;#\-()\s]+"
                validate={(values) => {
                  // prettier-ignore
                  const regex =/^[0-9:\,;#\(\)\s-]+$/g; //eslint-disable-line

                  if (values && !regex.test(values)) {
                    return 'Please enter a valid phone number. This can contain numbers and the following special characters: ( ) , : ;';
                  } else {
                    return false;
                  }
                }}>
                {({ input, meta }) => (
                  <React.Fragment>
                    <input
                      {...input}
                      type="tel"
                      pattern="[0-9:,;#\-()\s]+"
                      className={
                        meta.error
                          ? 'form-item__field--noInvalid form-item__field--noInvalid--error'
                          : 'form-item__field--noInvalid'
                      }
                    />
                    {meta.error && (
                      <span className="form-item__field-message--required text-small">
                        {meta.error}
                      </span>
                    )}
                  </React.Fragment>
                )}
              </Field>
            </div>
            <div className="item-container__info-container">
              <HelpIcon
                onClick={() => contactPhoneHelpTextRef.current.toggleHelpText()}
                toggled={showContactPhoneHelpText}
                styles="margin-left-5"
              />
            </div>
          </div>
          <InlineHelpText
            ref={contactPhoneHelpTextRef}
            toggleFunction={toggleContactPhoneHelpText}
            message={contactPhoneHelpText}
          />
        </div>
        <div className="content-display__column content-display__column--1-2">
          <Condition when="hasPhoneDevice" is={false}>
            <AccessControl
              data-test="access-control"
              feature={permissions.static.devices.alert.addAlertDevice}>
              
              <div className="content-display__item-container">
                <div className="item-container__main-container">
                  <Field
                    className="visually-hidden"
                    name="makePhoneAlertDevice"
                    component="input"
                    type="checkbox"
                    id="makePhoneAlertDevice"
                    disabled={values.phone === '' || values.phone === undefined}
                  />
                  <label
                    htmlFor="makePhoneAlertDevice"
                    className={
                      values.phone === '' || values.phone === undefined
                        ? 'text-large text-dimmed text-light form-item__field-toggle'
                        : 'text-large text-light text-deep-blue form-item__field-toggle'
                    }>
                    <FormattedMessage
                      id="userContactForm.makePhoneAlertDeviceText"
                      defaultMessage="Create an alert device using this phone number"
                      description="The user's title such as 'Mr', 'Ms','Dr', etc "
                    />
                  </label>
                </div>
                <div className="item-container__info-container">
                  <HelpIcon
                    onClick={() =>
                      makePhoneAlertDeviceHelpTextRef.current.toggleHelpText()
                    }
                    toggled={showMakePhoneAlertDeviceHelpText}
                    styles="margin-left-5"
                  />
                </div>
              </div>
            </AccessControl>
          </Condition>
          <InlineHelpText
            ref={makePhoneAlertDeviceHelpTextRef}
            toggleFunction={toggleShowMakePhoneAlertDeviceHelpText}
            message={makePhoneAlertDeviceHelpText}
          />
        </div>


        <div className="width-100"></div>
        
        
       {/* Mass Notification field if toggle is true for six devices */}
        <div className="content-display__column content-display__column--1-2">
          <Condition when="makeMassnotification" is={true}> 
          <div className="content-display__item-container">
            <div className="item-container__main-container">
              <label className="text-large text-light text-deep-blue">
                <FormattedMessage
                  id="userContactForm.contactMassnotificationWorkPhone"
                  defaultMessage="Work Phone Number:"
                  description="The user's work phone contact for mass notification"
                />
              </label>
              <Field
                className="form-item__field"
                name="Mass notification work"
                component="input"
                type="tel"
                pattern="[0-9:,;#\-()\s]+"
                validate={(values) => {
                  // prettier-ignore
                  const regex =/^[0-9:\,;#\(\)\s-]+$/g; //eslint-disable-line

                  if (values && !regex.test(values)) {
                    return 'Please enter a valid phone number. This can contain numbers and the following special characters: ( ) , : ;';
                  } else {
                    return false;
                  }
                }}>
                {({ input, meta }) => (
                  <React.Fragment>
                    <input
                      {...input}
                      type="tel"
                      pattern="[0-9:,;#\-()\s]+"
                      className={
                        meta.error
                          ? 'form-item__field--noInvalid form-item__field--noInvalid--error'
                          : 'form-item__field--noInvalid'
                      }
                    />
                    {meta.error && (
                      <span className="form-item__field-message--required text-small">
                        {meta.error}
                      </span>
                    )}
                  </React.Fragment>
                )}
              </Field>
              </div>
            </div>  
            </Condition>
          </div>     



            
           
       {/* The content would only appear if a site is using Mass Notification, the state used for massNotificationAccess will indicate system parameter value ecn_lc */}
       <div className="content-display__column content-display__column--1-2">
           <ConditionMassnotificationSysParams massnotificationSysParams={massNotificationAccess}>
            <AccessControl
               data-test="access-control"
              feature={permissions.static.devices.alert.addAlertDevice}>
              <div className="content-display__item-container">
                  
                <div className="item-container__main-container">
                  
                  <Field
                    className="visually-hidden"
                    name="makeMassnotification"
                    component="input"
                    type="checkbox"
                    id="makeMassnotification"
                    //Boolean used to switch toggle on and off for mass notification fields to be displayed for user
                    enable={values.makeMassnotification === true || values.makeMassnotification == null}
                    
                  />
                  <label
                    htmlFor="makeMassnotification"
                    className={
                      values.makeMassnotification === true || values.makeMassnotification == null
                        ? 'text-large text-dimmed text-light form-item__field-toggle'
                        : 'text-large text-light text-deep-blue form-item__field-toggle'
                    }>
                    <FormattedMessage
                      id="userContactForm.makeMassnotificationDeviceText"
                      defaultMessage="Create a mass notification contact for this user"
                      description="The user's title such as 'Mr', 'Ms','Dr', etc "
                    />
                  </label>
                </div>
                <div className="item-container__info-container">
                  <HelpIcon
                    onClick={() =>
                      makeMassnotificationDeviceHelpTextRef.current.toggleHelpText()
                    }
                    toggled={showMakeMassnotificationDeviceHelpText}
                    styles="margin-left-5"
                  />
                </div>
              </div>
            </AccessControl>
          </ConditionMassnotificationSysParams>
          <InlineHelpText
            ref={makeMassnotificationDeviceHelpTextRef}
            toggleFunction={toggleShowMakeMassnotificationDeviceHelpText}
            message={makeMassnotificationDeviceHelpText}
          />
        </div>
  


                  
        <div className="content-display__column content-display__column--1-2">
        <Condition when="makeMassnotification" is={true}> 
          <div className="item-container__main-container">
          <div className="content-display__item-container">
              <label className="text-large text-light text-deep-blue">
                <FormattedMessage
                  id="userContactForm.contactMassnotificationText"
                  defaultMessage="Text Message:"
                  description="The user's text message contact for mass notification"
                />
              </label>
            </div>
              <Field
                className="form-item__field"
                name="Mass notification Text"
                component="input"
                type="tel"
                pattern="[0-9:,;#\-()\s]+"
                validate={(values) => {
                  // prettier-ignore
                  const regex =/^[0-9:\,;#\(\)\s-]+$/g; //eslint-disable-line

                  if (values && !regex.test(values)) {
                    return 'Please enter a valid phone number. This can contain numbers and the following special characters: ( ) , : ;';
                  } else {
                    return false;
                  }
                }}>
                {({ input, meta }) => (
                  <React.Fragment>
                    <input
                      {...input}
                      type="tel"
                      pattern="[0-9:,;#\-()\s]+"
                      className={
                        meta.error
                          ? 'form-item__field--noInvalid form-item__field--noInvalid--error'
                          : 'form-item__field--noInvalid'
                      }
                    />
                    {meta.error && (
                      <span className="form-item__field-message--required text-small">
                        {meta.error}
                      </span>
                    )}
                  </React.Fragment>
                )}
              </Field>
              </div>
            </Condition>
              </div>

              
            <div className="content-display__column content-display__column--1-2">
              <Condition when="makeMassnotification" is={true}>  
              <div className="content-display__item-container"> 
              <div className="item-container__main-container">       
              <label className="text-large text-light text-deep-blue">
                <FormattedMessage
                  id="userContactForm.contactMassnotificationSecondary"
                  defaultMessage="Secondary Phone Number:"
                  description="The user's secondary phone contact for mass notification"
                />
              </label>
              <Field
                className="form-item__field"
                name="Mass notification Secondary Phone"
                component="input"
                type="tel"
                pattern="[0-9:,;#\-()\s]+"
                validate={(values) => {
                  // prettier-ignore
                  const regex =/^[0-9:\,;#\(\)\s-]+$/g; //eslint-disable-line

                  if (values && !regex.test(values)) {
                    return 'Please enter a valid phone number. This can contain numbers and the following special characters: ( ) , : ;';
                  } else {
                    return false;
                  }
                }}>
                {({ input, meta }) => (
                  <React.Fragment>
                    <input
                      {...input}
                      type="tel"
                      pattern="[0-9:,;#\-()\s]+"
                      className={
                        meta.error
                          ? 'form-item__field--noInvalid form-item__field--noInvalid--error'
                          : 'form-item__field--noInvalid'
                      }
                    />
                    {meta.error && (
                      <span className="form-item__field-message--required text-small">
                        {meta.error}
                      </span>
                    )}
                  </React.Fragment>
                )}
              </Field>
              </div>
              </div>
              </Condition>
            </div> 


            
          <div className="content-display__column content-display__column--1-2"> 
            <Condition when="makeMassnotification" is={true}> 
            <div className="content-display__item-container">
            <div className="item-container__main-container">
              <label className="text-large text-light text-deep-blue">
                <FormattedMessage
                  id="userContactForm.contactMassnotificationWorkEmail"
                  defaultMessage="Work Email Address:"
                  description="The user's work email address contact for mass notification"
                />
              </label>
              
              <Field
                className="form-item__field"
                name="work email"
                component="input"
                type="email"
                pattern="^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$"
                validate={(values) => {
                  const regex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
                  if (values) {
                    if (regex.test(values)) {
                      return undefined;
                    } else {
                      return 'Please use the following format: xxx@xx.xxx';
                    }
                  } else {
                    return undefined;
                  }
                }}>
                {({ input, meta }) => (
                  <React.Fragment>
                    <input
                      {...input}
                      type="email"
                      pattern="/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/"
                      className={
                        meta.error
                          ? 'form-item__field--noInvalid form-item__field--noInvalid--error'
                          : 'form-item__field--noInvalid'
                      }
                    />
                    {meta.error && (
                      <span className="form-item__field-message--required text-small">
                        {meta.error}
                      </span>
                    )}
                  </React.Fragment>
                )}
              </Field>
              </div>
              </div>
              </Condition>
            </div>

              
            <div className="content-display__column content-display__column--1-2">
              <Condition when="makeMassnotification" is={true}>
              <div className="content-display__item-container">
              <div className="item-container__main-container">
              <label className="text-large text-light text-deep-blue">
                <FormattedMessage
                  id="userContactForm.contactMassnotificationPersonalEmail"
                  defaultMessage="Personal Email Address:"
                  description="The user's email address mass notification"
                />
              </label>
              <Field
                className="form-item__field"
                name="personal email"
                component="input"
                type="email"
                pattern="^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$"
                validate={(values) => {
                  const regex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
                  if (values) {
                    if (regex.test(values)) {
                      return undefined;
                    } else {
                      return 'Please use the following format: xxx@xx.xxx';
                    }
                  } else {
                    return undefined;
                  }
                }}>
                {({ input, meta }) => (
                  <React.Fragment>
                    <input
                      {...input}
                      type="email"
                      pattern="/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/"
                      className={
                        meta.error
                          ? 'form-item__field--noInvalid form-item__field--noInvalid--error'
                          : 'form-item__field--noInvalid'
                      }
                    />
                    {meta.error && (
                      <span className="form-item__field-message--required text-small">
                        {meta.error}
                      </span>
                    )}
                  </React.Fragment>
                )}
              </Field>
              </div>
              </div>
            </Condition>
            </div>

              
            <div className="content-display__column content-display__column--1-2">
              <Condition when="makeMassnotification" is={true}>
              <div className="content-display__item-container">
              <div className="item-container__main-container">
              <label className="text-large text-light text-deep-blue">
                <FormattedMessage
                  id="userContactForm.contactMassnotificationSecondaryEmail"
                  defaultMessage="Secondary Email Address:"
                  description="The user's secondary email address mass notification"
                />
              </label>
              
              <Field
                className="form-item__field"
                name="secondary email"
                component="input"
                type="email"
                pattern="^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$"
                validate={(values) => {
                  const regex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
                  if (values) {
                    if (regex.test(values)) {
                      return undefined;
                    } else {
                      return 'Please use the following format: xxx@xx.xxx';
                    }
                  } else {
                    return undefined;
                  }
                }}>
                {({ input, meta }) => (
                  <React.Fragment>
                    <input
                      {...input}
                      type="email"
                      pattern="/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/"
                      className={
                        meta.error
                          ? 'form-item__field--noInvalid form-item__field--noInvalid--error'
                          : 'form-item__field--noInvalid'
                      }
                    />
                    {meta.error && (
                      <span className="form-item__field-message--required text-small">
                        {meta.error}
                      </span>
                    )}
                  </React.Fragment>
                )}
              </Field>
              </div>
              </div>
              </Condition>
            </div>

    
        <div className="width-100"></div>
      </div>
     
    </React.Fragment>  
  );
}
const mapStateToProps = (state, ownProps) => {
  const userStatuses = Object.values(state.users.userStatuses);
  console.log(
    state
  );
  return {
    userStatuses,
    // The state used to enable massNotificationAccess
    massNotificationAccess:state.system.sysParams.massNotificationAccess,
    };
};

export default connect(mapStateToProps)(UnconnectedUserContactForm);
